import { styled, selectTheme } from '@creditas-ui/react'

export const Wrapper = styled.section`
  background-color: ${selectTheme('colors.neutral.0')};
  height: 100%;
  padding: ${selectTheme('spacingX.21xl')};
  position: fixed;
  right: 0;
  top: 0;
  width: 40%;
  max-width: 624px;
  overflow-y: auto;
  outline: 0;
  z-index: 9;
`

export const CloseButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  position: absolute;
  top: 50px;
  right: 70px;
`

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 8;
`
